import {
  FETCH_STARTER_KIT_COMPONENTS_REQUEST,
  FETCH_STARTER_KIT_COMPONENTS_SUCCESS,
  FETCH_STARTER_KIT_COMPONENTS_FAILURE,

  CREATE_STARTER_KIT_COMPONENT_REQUEST,
  CREATE_STARTER_KIT_COMPONENT_SUCCESS,
  CREATE_STARTER_KIT_COMPONENT_FAILURE,

  UPDATE_STARTER_KIT_COMPONENT_REQUEST,
  UPDATE_STARTER_KIT_COMPONENT_SUCCESS,
  UPDATE_STARTER_KIT_COMPONENT_FAILURE,

  DELETE_STARTER_KIT_COMPONENT_REQUEST,
  DELETE_STARTER_KIT_COMPONENT_SUCCESS,
  DELETE_STARTER_KIT_COMPONENT_FAILURE,
} from "./types";


import {
  fetchStarterKitComponents,
  createStarterKitComponent,
  updateStarterKitComponent,
  deleteStarterKitComponent,
} from "../../services/starterKitComponentService";



export const fetchStarterKitComponentsRequest = () => ({
  type: FETCH_STARTER_KIT_COMPONENTS_REQUEST,
});


export const fetchStarterKitComponentsSuccess = (
  components
) => ({
  type: FETCH_STARTER_KIT_COMPONENTS_SUCCESS,
  payload: components,
});


export const fetchStarterKitComponentsFailure = (
  error
) => ({
  type: FETCH_STARTER_KIT_COMPONENTS_FAILURE,
  payload: error,
});



export const createStarterKitComponentRequest = () => ({
  type: CREATE_STARTER_KIT_COMPONENT_REQUEST,
});


export const createStarterKitComponentSuccess = (
  component
) => ({
  type: CREATE_STARTER_KIT_COMPONENT_SUCCESS,
  payload: component,
});


export const createStarterKitComponentFailure = (
  error
) => ({
  type: CREATE_STARTER_KIT_COMPONENT_FAILURE,
  payload: error,
});



export const updateStarterKitComponentRequest = () => ({
  type: UPDATE_STARTER_KIT_COMPONENT_REQUEST,
});


export const updateStarterKitComponentSuccess = (
  component
) => ({
  type: UPDATE_STARTER_KIT_COMPONENT_SUCCESS,
  payload: component,
});


export const updateStarterKitComponentFailure = (
  error
) => ({
  type: UPDATE_STARTER_KIT_COMPONENT_FAILURE,
  payload: error,
});



export const deleteStarterKitComponentRequest = () => ({
  type: DELETE_STARTER_KIT_COMPONENT_REQUEST,
});


export const deleteStarterKitComponentSuccess = (
  componentId
) => ({
  type: DELETE_STARTER_KIT_COMPONENT_SUCCESS,
  payload: componentId,
});


export const deleteStarterKitComponentFailure = (
  error
) => ({
  type: DELETE_STARTER_KIT_COMPONENT_FAILURE,
  payload: error,
});


export const fetchStarterKitComponentsAction =
  () => async (dispatch) => {

    dispatch(
      fetchStarterKitComponentsRequest()
    );

    try {

      const response =
        await fetchStarterKitComponents();

      if (response.success) {

        dispatch(
          fetchStarterKitComponentsSuccess(
            response.data
          )
        );

      } else {

        dispatch(
          fetchStarterKitComponentsFailure(
            response.error
          )
        );

      }

      return response;

    } catch (error) {

      const message =
        error.message ||
        "Failed to fetch Starter Kit Components";

      dispatch(
        fetchStarterKitComponentsFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };



export const createStarterKitComponentAction =
  (payload) => async (dispatch) => {

    dispatch(
      createStarterKitComponentRequest()
    );

    try {

      const response =
        await createStarterKitComponent(
          payload
        );

      if (response.success) {

        dispatch(
          createStarterKitComponentSuccess(
            response.data
          )
        );

      } else {

        dispatch(
          createStarterKitComponentFailure(
            response.error
          )
        );

      }

      return response;

    } catch (error) {

      const message =
        error.message ||
        "Failed to create Starter Kit Component";

      dispatch(
        createStarterKitComponentFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };


export const updateStarterKitComponentAction =
  (
    componentId,
    payload
  ) => async (dispatch) => {

    dispatch(
      updateStarterKitComponentRequest()
    );

    try {

      const response =
        await updateStarterKitComponent(
          componentId,
          payload
        );

      if (response.success) {

        dispatch(
          updateStarterKitComponentSuccess(
            response.data
          )
        );

      } else {

        dispatch(
          updateStarterKitComponentFailure(
            response.error
          )
        );

      }

      return response;

    } catch (error) {

      const message =
        error.message ||
        "Failed to update Starter Kit Component";

      dispatch(
        updateStarterKitComponentFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };


export const deleteStarterKitComponentAction =
  (componentId) => async (dispatch) => {

    dispatch(
      deleteStarterKitComponentRequest()
    );

    try {

      const response =
        await deleteStarterKitComponent(
          componentId
        );

      if (response.success) {

        dispatch(
          deleteStarterKitComponentSuccess(
            componentId
          )
        );

      } else {

        dispatch(
          deleteStarterKitComponentFailure(
            response.error
          )
        );

      }

      return response;

    } catch (error) {

      const message =
        error.message ||
        "Failed to delete Starter Kit Component";

      dispatch(
        deleteStarterKitComponentFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };